import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import PageWrapper from 'components/PageWrapper';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { createKickstartRequest } from 'services/account.service';
import { getMediaUrl, uploadMedia } from 'services/media';
import { TYPES, queueMsg } from 'services/rabbit.service';
import { fromValuesToKickstartVariables } from 'utils/kickstart';
import toast from 'utils/toast';
import TICFrom from './tic.form';

const HOOK = `https://hooks.zapier.com/hooks/catch/465525/b3vmv39`;
const isDev = process.env.NODE_ENV === 'development';

function buildEmail(data, account, title) {
  return `
      <h1>${title}</h1>
      <p>Member ID: ${account.member_id}</p>
      <h2>Primary Contact</h2>
      <p>${data.first_name} ${data.last_name}</p>
      <p>Email: ${data.email}</p>
      <p>Position: ${data.position_at_church}</p>  
      <p>Salutation: ${data.salutation}</p>
      <h2>Secondary Contact</h2>
      <p>${data.first_name_2} ${data.last_name_2}</p>
      <p>Email: ${data.email_2}</p>
      <p>Position: ${data.position_at_church_2}</p>  
      <p>Salutation: ${data.salutation_2}</p>
      <h2>Church Information</h2>
      <p>Church Name: ${data.church_name}</p>
      <p>Church Phone: ${data.church_phone}</p>
      <p>When, where and what time will Coffee with the Pastors be held?: ${
        data.coffee_with_pastors
      }</p>
      <p>Service Times: ${data.service_times}</p>
      <p>Address of Service Location: ${data.service_address}</p>
      <p>Nursery Details: ${data.nursery_details}</p>
      <p>Sunday School Details: ${data.sunday_school_details}</p>
      <p>What to Wear: ${data.outfit_details}</p>
      <p>Guest Services Offered: ${data.guest_services}</p>
      <p>Church Website URL: ${data.church_website_url}</p>
      <p>Church Facebook URL: ${data.facebook_page_url}</p>
      <p>Giving URL: ${data.giving_url}</p>
      <h2>Groups</h2>
      <p>
        ${data.groups.map((g) => g.label).join(', ')}
      </p>
    `;
}

const Kickstart = ({ type = '' }) => {
  const [t] = useTranslation('igniterkit' + type);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const account = useSelector((s) => s.settings.account);

  const handleSubmit = async (values, GROUPS) => {
    try {
      setSubmitting(true);
      const groups = [];
      Object.keys(values.groups ?? {}).forEach((key) => {
        const val = values.groups[key];
        if (val) {
          const g = GROUPS.find((i) => i.value === key);
          groups.push(g);
        }
      });
      values.group_ids = groups.map((i) => i.value);
      values.groups = groups;
      values.account_id = account.account_id;
      values.account_hash = account.hash;
      if (values.csv_import && values.csv_import.target) {
        const file = values.csv_import.target.files[0];
        if (file) {
          const { location } = await uploadMedia(file, 2);
          values.csv_import = await getMediaUrl(location);
        }
      }
      const title = t('igniter-kit-submission', 'Igniter kit Submission');
      const html = buildEmail(values, account, title);
      delete values.groups;
      await createKickstartRequest(
        fromValuesToKickstartVariables(values, type),
        type === 'easter' ? 'kickstart_easter' : 'kickstart',
      );

      if (!isDev) {
        await Promise.all([
          await axios
            .get(HOOK, {
              params: {
                msg_subject: `Igniter kit ${type} Submission From ${values.first_name} ${values.last_name}`,
                account_id: account.account_id,
                member_id: account.member_id,
                account_email: account.account_email,
                msg_content: html,
                type,
                values,
              },
            })
            .catch((e) => console.log(e)),
        ]);
      }

      setSubmitting(false);
      setSubmitted(true);
    } catch (e) {
      toast.error(e.message);
      setSubmitting(false);
    }
  };

  return (
    <PageWrapper>
      <Helmet>
        <title>{t('page-title', 'Igniter Kit')}</title>
      </Helmet>
      <>
        {submitted ? (
          <Box textAlign="center">
            <Typography variant="h1">Thank You</Typography>
            <Typography variant="h4">
              A member of our team will contact you soon.
            </Typography>
          </Box>
        ) : (
          <TICFrom
            type={type}
            onSubmit={handleSubmit}
            submitting={submitting}
          />
        )}
      </>
    </PageWrapper>
  );
};

export default Kickstart;
